import React from "react"
import InputRadioButton from "../../../components/atoms/InputRadioButton.atom"

/**
 * @typedef {import("primereact/checkbox").CheckboxProps & { label: string }} InputCheckboxProps
 */

/**
 * Componente de checkbox para formularios
 * @param {InputCheckboxProps} props
 * @returns
 */
export function VacationDaysRadioButton({
  label,
  usedDays,
  onChangeUsedDays,
  availableDays,
  className = "",
}) {
  return (
    <div className={`vacation-days-radio-button ${className}`}>
      <div className={`vacation-days-radio-button__selector`}>
        <InputRadioButton
          checked={usedDays > 0}
          value={1}
          onChange={onChangeUsedDays}
        />
        <label className="vacation-days-radio-button__label">{label}</label>
      </div>
      <label
        className={`vacation-days-radio-button__available-days ${availableDays < 0 ? "vacation-days-radio-button__available-days--error" : ""}`}
      >
        Disponibles: {availableDays}
      </label>
    </div>
  )
}
